/** "1 h 58 min" / "12 min" / "3 d 4 h" for a positive duration in ms; "now" when ≤ 0. */
export function formatDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms <= 0) return "now";

  const min = Math.round(ms / 60_000);

  if (min < 60) return `${min} min`;

  const h = Math.floor(min / 60);
  const m = min % 60;

  if (h < 24) return m ? `${h} h ${m} min` : `${h} h`;

  const d = Math.floor(h / 24);
  const hh = h % 24;
  return hh ? `${d} d ${hh} h` : `${d} d`;
}
